export var ConditionPart;
(function (ConditionPart) {
    ConditionPart[ConditionPart["EntityAttr"] = 2] = "EntityAttr";
    ConditionPart[ConditionPart["Operator"] = 4] = "Operator";
    ConditionPart[ConditionPart["Value"] = 8] = "Value";
    ConditionPart[ConditionPart["All"] = 14] = "All";
})(ConditionPart || (ConditionPart = {}));
//# sourceMappingURL=cond_part.js.map